import React from 'react';
import { connect } from 'react-redux';

import { TableContainer } from 'apps/auth/components/common/components/TableRow/styles';
import { TableRow } from 'apps/auth/components/common/components/TableRow/TableRow';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import ActivityAmount from 'apps/auth/components/ga/activity/components/ActivityAmount';
import ActivityIcon from 'apps/auth/components/ga/activity/components/ActivityIcon';
import ActivityStatus from 'apps/auth/components/ga/activity/components/ActivityStatus';
import ActivityTitle from 'apps/auth/components/ga/activity/components/ActivityTitle';
import {
    CATEGORY_TRANSFER_FROM_FLINKS,
    CATEGORY_TRANSFER_TO_CASH,
    CATEGORY_TRANSFER_TO_INTERAC,
    CATEGORY_TRANSFER_TO_PEOPLE_TRUST_INTERAC,
    STATUS_OK,
} from 'apps/auth/constants/Constants';
import { AUTH_PAYMENTS_HISTORY } from 'apps/auth/constants/UrlConstants';
import { formatMoney } from 'apps/auth/helpers/formats';
import { getGaActivityDate } from 'apps/auth/helpers/utils';

const CommonPaymentDetails = (props) => {
    const item = props.item;
    const mobileInfo = item.mobileInfo;
    const { textColor, titleColor } = props.options;

    const getStatusText = () => {
        let statusText = props.chequeStatusInProgress;
        if (item.mobileInfo.stsId < STATUS_OK && item.fromchequeBankAccountStatusBean) {
            statusText = props.chequeAccountStatusInProgress;
            // <c:set var="cssClassStatus" value="sending"/>
        } else if (
            item.mobileInfo.stsId < STATUS_OK &&
            (item.providerToCategory === CATEGORY_TRANSFER_TO_INTERAC || item.providerToCategory === CATEGORY_TRANSFER_TO_PEOPLE_TRUST_INTERAC) &&
            item.secretCode
        ) {
            statusText = props.chequeInteracStatusInProgress;
        } else if (item.mobileInfo.stsId < STATUS_OK && item.providerFromCategory === CATEGORY_TRANSFER_FROM_FLINKS) {
            statusText = props.chequeStatusFlinksInProgress;
        } else if (item.mobileInfo.stsId < STATUS_OK && item.providerFromCategory === CATEGORY_TRANSFER_TO_CASH && item.secretCode) {
            statusText = props.chequeCashStatusInProgress;
        } else if (
            item.mobileInfo.stsId === STATUS_OK &&
            (item.providerToCategory === CATEGORY_TRANSFER_TO_INTERAC || item.providerToCategory === CATEGORY_TRANSFER_TO_PEOPLE_TRUST_INTERAC)
        ) {
            statusText = props.chequeInteracStatusSuccess;
        } else if (item.mobileInfo.stsId < STATUS_OK && item.waitingVerification) {
            statusText = props.chequeStatusWaitingVerification;
        } else if (item.mobileInfo.stsId === STATUS_OK) {
            statusText = props.chequeStatusSuccess;
        } else if (item.mobileInfo.stsId > STATUS_OK && (item.cancellingProcess || item.errorCode === 69)) {
            statusText = props.chequeStatusCanceled;
        } else if (item.mobileInfo.stsId > STATUS_OK) {
            statusText = props.chequeStatusError;
        }
        return statusText;
    };

    const getSpecialStatus = () => {
        let statusMessage;

        if (item.status > STATUS_OK && item.errorCode !== 69) {
            statusMessage = item.errorMessage;
        } else if (
            item.status >= 10 &&
            item.status < STATUS_OK &&
            (item.providerToCategory === CATEGORY_TRANSFER_TO_INTERAC || item.providerToCategory === CATEGORY_TRANSFER_TO_PEOPLE_TRUST_INTERAC) &&
            !item.secretCode
        ) {
            statusMessage = props.chequeInteracStatusSpecialInfo;
        } else if (item.status < STATUS_OK && item.providerFromCategory === CATEGORY_TRANSFER_FROM_FLINKS) {
            statusMessage = props.chequeFlinksStatusSpecialInfo;
        }

        if (statusMessage) {
            return <DangerouslyHtml dangerouslyHtml={statusMessage} />;
        }
    };

    return (
        <>
            <Row indent="adaptive-16-24">
                <ActivityIcon item={item} options={props.options} />
            </Row>
            <ActivityTitle message={mobileInfo.title} color={textColor} />
            <Row indent="adaptive-24-32">
                <ActivityAmount options={props.options} item={item} useArrow />
                <ActivityAmount options={props.options} item={item} isFrom={false} />
                {item.payComment && (
                    <Text variant="paragraph" ellipsis color="secondary">
                        {item.payComment}
                    </Text>
                )}
            </Row>
            <Row indent={mobileInfo.errorMessage ? 'adaptive-16-24' : null}>
                <ActivityStatus isShowStatus status={mobileInfo.stsId} text={getStatusText()} />
            </Row>
            {getSpecialStatus()}

            {mobileInfo.stsId < STATUS_OK && item.fromBankAccountStatusBean && (
                <>
                    <Separator marginBottom="16px" />
                    <Panel
                        isHoverable
                        type="reactLink"
                        to={`${AUTH_PAYMENTS_HISTORY}?paymentId=${item.paymentId}`}
                        id={`pay_info_${item.paymentId}`}
                        negativeMargin
                    >
                        <DiskBadgeWrapper>
                            <DiskBadge variant="primary" iconName="retry" />
                        </DiskBadgeWrapper>
                        <Text color="primary">{props.payBankTransferButton}</Text>
                    </Panel>
                </>
            )}

            <Separator marginTop="48px" marginBottom={mobileInfo.stsId < STATUS_OK && item.fromBankAccountStatusBean ? '16px' : '48px'} />
            <TableContainer>
                <TableRow title={props.chequeDate} textColor={textColor} titleColor={titleColor}>
                    {getGaActivityDate(item.payTs, props.lang)}
                </TableRow>
                <TableRow title={props.chequeFee} textColor={textColor} titleColor={titleColor}>
                    {formatMoney(mobileInfo.feeUp)} {mobileInfo.frCurIso}
                </TableRow>
                {mobileInfo.curRate && (
                    <TableRow title={props.chequeFxRate} textColor={textColor} titleColor={titleColor}>
                        {`${formatMoney(1)} ${mobileInfo.frCurIso} = ${formatMoney(mobileInfo.curRate, 4)} ${mobileInfo.toCurIso}`}
                    </TableRow>
                )}
                {item.promoCode && (
                    <TableRow title={props.chequePromocodeFaild} textColor={textColor} titleColor={titleColor}>
                        {item.promoCode}
                    </TableRow>
                )}
            </TableContainer>

            <Separator marginTop="48px" marginBottom="48px" />
            <TableContainer>
                {mobileInfo.extraFields.Recipient && (
                    <TableRow title={props.chequeRecipientHeader} textColor={textColor} titleColor={titleColor}>
                        {mobileInfo.extraFields.Recipient}
                    </TableRow>
                )}
                {item.toBankName && (
                    <TableRow
                        title={props.chequeBlockBankHeader}
                        textColor={textColor}
                        titleColor={titleColor}
                    >{`${item.toBankName} · ${item.toBankCountryName}`}</TableRow>
                )}
                {item.providerToCategory === CATEGORY_TRANSFER_TO_INTERAC && (
                    <TableRow
                        title={props.chequeBlockProviderHeader}
                        textColor={textColor}
                        titleColor={titleColor}
                    >{`${props.chequeRecipientInterac} · ${item.toBankCountryName}`}</TableRow>
                )}
                {item.providerToCategory === CATEGORY_TRANSFER_TO_PEOPLE_TRUST_INTERAC && (
                    <TableRow
                        title={props.chequeBlockProviderHeader}
                        textColor={textColor}
                        titleColor={titleColor}
                    >{`${props.chequeRecipientPeopleTrustInterac} · ${item.toBankCountryName}`}</TableRow>
                )}
            </TableContainer>
        </>
    );
};

const mapStateToProps = (state) => ({
    chequeInteracStatusInProgress: state.messages.pageMessages.chequeInteracStatusInProgress,
    chequeInteracStatusSuccess: state.messages.pageMessages.chequeInteracStatusSuccess,
    chequeInteracStatusSpecialInfo: state.messages.pageMessages.chequeInteracStatusSpecialInfo,
    chequeCashStatusInProgress: state.messages.pageMessages.chequeCashStatusInProgress,
    chequeRecipientHeader: state.messages.pageMessages.chequeRecipientHeader,
    payBankTransferButton: state.messages.pageMessages.payBankTransferButton,
    chequeStatusInProgress: state.messages.pageMessages.chequeStatusInProgress,
    chequeStatusFlinksInProgress: state.messages.pageMessages.chequeStatusFlinksInProgress,
    chequeFlinksStatusSpecialInfo: state.messages.pageMessages.chequeFlinksStatusSpecialInfo,
    chequeAccountStatusInProgress: state.messages.pageMessages.chequeAccountStatusInProgress,
    chequeStatusWaitingVerification: state.messages.pageMessages.chequeStatusWaitingVerification,
    chequeStatusSuccess: state.messages.pageMessages.chequeStatusSuccess,
    chequePromocodeFaild: state.messages.pageMessages.chequePromocodeFaild,
    chequeStatusCanceled: state.messages.pageMessages.chequeStatusCanceled,
    chequeStatusError: state.messages.pageMessages.chequeStatusError,
    chequeDate: state.messages.pageMessages.chequeDate,
    chequeFee: state.messages.pageMessages.chequeFee,
    chequeRecipientInterac: state.messages.pageMessages.chequeRecipientInterac,
    chequeRecipientPeopleTrustInterac: state.messages.pageMessages.chequeRecipientInterac,
    chequeFxRate: state.messages.pageMessages.chequeFxRate,
    chequeBlockProviderHeader: state.messages.pageMessages.chequeBlockProviderHeader,
    chequeBlockBankHeader: state.messages.pageMessages.chequeBlockBankHeader,
    lang: state.language.lang,
});

export default connect(mapStateToProps)(CommonPaymentDetails);
